import './Toolbar.scss'

import { RightCircleFilled, ShoppingCartOutlined, UserOutlined } from '@ant-design/icons/lib/icons'
import { Badge, Button, Dropdown, MenuProps, Modal, notification } from 'antd'
import { AppRoutes } from 'App'
import SelectBranchModal from 'components/select-branch-modal/SelectBranchModal'
import AppContext from 'context/AppContext'
import { useSepetQuery } from 'gql/GeneratedGraphqlTypes'
import { Okul } from 'gql/StaticTypes'
import React, { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { LISTE_DISI_URUNLER_KATEGORI_ID } from 'utils/const'
import { AuthState } from 'utils/types'

import { AccountMenuItems } from '../account-menu/AccountMenu'
import { AccountMenuItem } from '../account-menu/types'
import CommonDrawer from '../drawer/CommonDrawer'
import { ReactComponent as ClassListIcon } from './svg/classList.svg'
import { ReactComponent as OtherProductIcon } from './svg/otherProducts.svg'
interface Props {
  logo: string
  okul: Okul
}

const Toolbar: React.FC<Props> = (props) => {
  const { logo, okul } = props
  const appContext = useContext(AppContext)
  const [modalOpen, setModalOpen] = useState(false)
  const [closedWarningVisible, setClosedWarningVisible] = useState(false)

  const { authState, globalNotification, setGlobalNotification, slug } = appContext
  const { data: sepetData } = useSepetQuery({
    variables: { slug: slug ?? '' },
    skip: !slug || authState !== AuthState.LOGGED_IN,
    fetchPolicy: 'cache-and-network',
  })
  const sepetCesitSayisi = sepetData?.sepetTest?.urunler?.length ?? 0
  const navigate = useNavigate()
  const [drawerVisible, setDrawerVisible] = useState(false)
  const isMobile = window.innerWidth <= 768
  const onClassSelected = (selectedClassId: number) => {
    navigate(`/${AppRoutes.classProducts}/${selectedClassId}/`)
  }

  const handleSinifListesiClick = () => {
    if (okul.active === false) {
      setClosedWarningVisible(true)
    } else {
      setModalOpen(true)
    }
  }
  const handleNavigate = () => {
    if (okul.active === false) {
      setClosedWarningVisible(true)
      return
    }
    navigate(`/${AppRoutes.crossproduct}/${LISTE_DISI_URUNLER_KATEGORI_ID}/`)
  }

  useEffect(() => {
    if (globalNotification) {
      notification[globalNotification.type]({
        message: globalNotification.message,
        description: globalNotification.description,
        placement: 'topRight',
        duration: 6,
      })

      // Mesajı gösterdikten sonra sıfırla
      setGlobalNotification(null)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [globalNotification])
  const openDrawer = () => {
    setDrawerVisible(true)
  }

  const closeDrawer = () => {
    setDrawerVisible(false)
  }

  const onItemClick = (item: AccountMenuItem) => {
    item.onClick(navigate, appContext)
    closeDrawer()
  }

  const menuItems = AccountMenuItems.map((item, i) => (
    <Button key={i} icon={item.icon} onClick={() => onItemClick(item)} className={'menu-button'} type={'ghost'}>
      {item.title}
    </Button>
  ))
  const accountMenuItems: MenuProps['items'] = AccountMenuItems.map((item, i) => {
    return {
      key: i,
      label: (
        <Button
          icon={item.icon}
          onClick={() => {
            item.onClick(navigate, appContext)
          }}
          className={'menu-button'}
          type={'ghost'}
        >
          {item.title}
        </Button>
      ),
    }
  })

  return (
    <div className="toolbar">
      {isMobile ? (
        <div className="mobile-toolbar">
          <div className="toolbar-up">
            <img
              className="logo-img"
              src={logo}
        
              alt="logo"
              onClick={() => {
                navigate('/')
              }}
            />
            <div className="toolbar-content-right">
              {authState === AuthState.LOGGED_IN ? (
                <>
                  <Button
                    className="toolbar-auth-button"
                    icon={<UserOutlined className="toolbar-icon" />}
                    type="link"
                    onClick={openDrawer}
                  >
                    Hesabım
                  </Button>
                  <CommonDrawer
                    title="Hesap Menüsü"
                    isVisible={drawerVisible}
                    onClose={closeDrawer}
                    items={menuItems}
                  />

                  <Badge count={sepetCesitSayisi} size="small" offset={[-4, 4]}>
                    <Button
                      className="toolbar-auth-button"
                      icon={<ShoppingCartOutlined className="toolbar-icon" />}
                      type="link"
                      onClick={() => {
                        navigate(AppRoutes.basket)
                      }}
                    >
                      Sepetim
                    </Button>
                  </Badge>
                </>
              ) : (
                <Button
                  className="toolbar-auth-button"
                  icon={<UserOutlined className="toolbar-icon" />}
                  type="link"
                  onClick={() => {
                    navigate(AppRoutes.auth)
                  }}
                >
                  Üyelik
                </Button>
              )}
            </div>
          </div>
          <div className="toolbar-down">
            <Button
              onClick={handleSinifListesiClick}
              type="primary"
              icon={<RightCircleFilled />}
            >
              Sınıf Listesi Ürünleri
            </Button>

            {okul.capraz_urun_satisi_varmi && (
              <Button
                type="primary"
                icon={<RightCircleFilled />}
                onClick={handleNavigate}
                className="class-list-content"
              >
                Liste Dışı Ürünler
              </Button>
            )}
          </div>
          <SelectBranchModal onClassSelected={onClassSelected} modalOpen={modalOpen} setModalOpen={setModalOpen} />
          <Modal
            open={closedWarningVisible}
            onCancel={() => setClosedWarningVisible(false)}
            footer={null}
            centered
          >
            <p
              style={{ marginTop: 16 }}
              dangerouslySetInnerHTML={{
                __html: (okul.uyari || 'Okul şu an satışa kapalıdır.').replace(/&lt;/g, '<').replace(/&gt;/g, '>'),
              }}
            />
          </Modal>
        </div>
      ) : (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
          }}
        >
          <div className="toolbar-content">
            <div className="toolbar-content-left">
              {!isMobile && (
                <div className="toolbar-logo">
                  <img
                    src={logo}
                    alt="logo"
                    onClick={() => {
                      navigate('/')
                    }}
                  />
                </div>
              )}
            </div>
            <div className="toolbar-class-list">
              <div
                onClick={handleSinifListesiClick}
                className="class-list-content"
              >
                <ClassListIcon className="toolbar-icon" />
                Sınıf Listesi Ürünleri
                <RightCircleFilled />
              </div>

              {okul.capraz_urun_satisi_varmi && (
                <div onClick={handleNavigate} className="class-list-content">
                  <OtherProductIcon className="toolbar-icon" />
                  Liste Dışı Ürünler
                  <RightCircleFilled />
                </div>
              )}

              <SelectBranchModal onClassSelected={onClassSelected} modalOpen={modalOpen} setModalOpen={setModalOpen} />
              <Modal
                open={closedWarningVisible}
                onCancel={() => setClosedWarningVisible(false)}
                footer={null}
                centered
              >
                <p
                  style={{ marginTop: 16 }}
                  dangerouslySetInnerHTML={{
                    __html: (okul.uyari || 'Okul şu an satışa kapalıdır.').replace(/&lt;/g, '<').replace(/&gt;/g, '>'),
                  }}
                />
              </Modal>
            </div>
            <div className="toolbar-content-right">
              {authState === AuthState.LOGGED_IN ? (
                <>
                  <Dropdown menu={{ items: accountMenuItems }} placement="bottom" arrow={{ pointAtCenter: true }}>
                    <Button
                      className="toolbar-auth-button"
                      icon={<UserOutlined className="toolbar-icon" />}
                      type="link"
                      onClick={() => {
                        navigate(`/${AppRoutes.account.root}/${AppRoutes.account.myAccountInformation}`)
                      }}
                    >
                      Hesabım
                    </Button>
                  </Dropdown>

                  <Badge count={sepetCesitSayisi} size="small" offset={[-4, 4]}>
                    <Button
                      className="toolbar-auth-button"
                      icon={<ShoppingCartOutlined className="toolbar-icon" />}
                      type="link"
                      onClick={() => {
                        navigate(AppRoutes.basket)
                      }}
                    >
                      Sepetim
                    </Button>
                  </Badge>
                </>
              ) : (
                <Button
                  className="toolbar-auth-button"
                  icon={<UserOutlined className="toolbar-icon" />}
                  type="link"
                  onClick={() => {
                    navigate(AppRoutes.auth)
                  }}
                >
                  Üyelik
                </Button>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default Toolbar
